import anchorJS from 'anchor-js';

function gallerySetup() {
  document.querySelectorAll(".gallery-image").forEach((image) => {
    image.addEventListener("click", _e => {
      let clazz = "gallery-image--fullscreen";
      let fullscreen_image = image.cloneNode(true);
      document.body.classList.add(clazz);
      fullscreen_image.classList.add(clazz);
      fullscreen_image.addEventListener("click", () => {
        fullscreen_image.remove();
        document.body.classList.remove(clazz);
      });
      document.body.appendChild(fullscreen_image);
      setTimeout(() => {
        let source = fullscreen_image.querySelector("source");
        if (source) {
          source.sizes = "1500px";
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', e => {
  var anchors = new anchorJS();
  anchors.options.placement = 'left';
  anchors.add('article > h1, article > h2, article > h3');

  gallerySetup();
});
